import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

const EmailTemplate = ({ isOpen, onClose, emailData, isDark = false }) => {
  // Disable body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const { subject, sentTo, date, body } = emailData;

  const modalContent = (
    <div
      className="fixed inset-0 bg-black/80 flex items-center justify-center p-[16px]"
      style={{ zIndex: 99999 }}
      onClick={onClose}
    >
      {/* Modal Container */}
      <div
        className={`rounded-[10px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] p-[20px] flex flex-col gap-[16px] w-full max-w-[1000px] max-h-[90vh] overflow-auto transition-colors duration-200 ${
          isDark ? 'bg-[#161515]' : 'bg-white'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header with Subject and Close Button */}
        <div className="flex items-center gap-[16px]">
          <div className="flex-1 flex items-center gap-[6px]">
            <div
              className="w-[16px] h-[16px]"
              style={{
                backgroundColor: isDark ? '#b3b3b3' : '#072837',
                WebkitMaskImage: "url('/assets/icons/email.svg')",
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskSize: 'contain',
                WebkitMaskPosition: 'center',
                maskImage: "url('/assets/icons/email.svg')",
                maskRepeat: 'no-repeat',
                maskSize: 'contain',
                maskPosition: 'center'
              }}
              aria-hidden="true"
            />
            <p className={`font-semibold text-[16px] m-0 transition-colors duration-200 ${
              isDark ? 'text-white' : 'text-[#072837]'
            }`}>
              {subject}
            </p>
          </div>
          <button
            onClick={onClose}
            className={`flex items-center justify-center w-[20px] h-[20px] p-0 rounded-full border-0 cursor-pointer transition-colors ${
              isDark ? 'bg-[#686868] hover:bg-[#4b5563]' : 'bg-[#686868] hover:bg-[#4b5563]'
            }`}
            aria-label="Close"
          >
            <X className="w-[14px] h-[14px] text-white" strokeWidth={2.5} />
          </button>
        </div>

        {/* Meta Information */}
        <div className="flex flex-col gap-[6px]">
          <div className="flex gap-[6px] items-center">
            <p className={`font-semibold text-[16px] m-0 transition-colors duration-200 ${
              isDark ? 'text-white' : 'text-[#072837]'
            }`}>Date:</p>
            <p className={`font-normal text-[16px] m-0 transition-colors duration-200 ${
              isDark ? 'text-[#b0b0b0]' : 'text-[#686868]'
            }`}>{date}</p>
          </div>
          <div className="flex gap-[6px] items-center">
            <p className={`font-semibold text-[16px] m-0 transition-colors duration-200 ${
              isDark ? 'text-white' : 'text-[#072837]'
            }`}>Sent to:</p>
            <p className={`font-normal text-[16px] m-0 transition-colors duration-200 ${
              isDark ? 'text-[#b0b0b0]' : 'text-[#686868]'
            }`}>{sentTo}</p>
          </div>
        </div>

        {/* Email Body */}
        <div className={`p-[20px] rounded-[10px] flex flex-col gap-[14px] transition-colors duration-200 ${
          isDark ? 'bg-[#1a1a1a]' : 'bg-neutral-100'
        }`}>
          <div
            className={`font-normal text-[16px] leading-normal transition-colors duration-200 ${
              isDark ? 'text-[#f2f2f2]' : 'text-[#072837]'
            }`}
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default EmailTemplate;
